var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_387",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29015",
    "data-name": "Group 29015",
    transform: "translate(-3895 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3895, -4996)",
    filter: "url(#Ellipse_387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387-2",
    "data-name": "Ellipse 387",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-kia",
    transform: "translate(3912 -4984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50597",
    "data-name": "Path 50597",
    d: "M20,12C8.954,12,0,16.477,0,22S8.954,32,20,32s20-4.478,20-10S31.046,12,20,12Zm0,18.741c-9.736,0-17.658-3.922-17.658-8.741S10.263,13.261,20,13.261,37.656,17.181,37.656,22,29.736,30.741,20,30.741Z",
    fill: "#d50000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50598",
    "data-name": "Path 50598",
    d: "M19.386,18.6h.33a.177.177,0,0,1,.177.2v8.989a.213.213,0,0,0,.22.211h2.458a.213.213,0,0,0,.221-.211V18.212A.217.217,0,0,0,22.571,18H19.386c-.032,0-.032.029-.032.052v.5C19.354,18.573,19.354,18.6,19.386,18.6ZM24.867,28h2.378a.331.331,0,0,0,.285-.208l2.028-6.206s.023-.087.1-.087.1.086.1.087l2.05,6.206A.326.326,0,0,0,32.09,28h2.377a.189.189,0,0,0,.157-.073.215.215,0,0,0,.036-.184l-3.308-9.6a.277.277,0,0,0-.288-.14H27.221a.056.056,0,0,0-.054.052v.5a.057.057,0,0,0,.054.052h.327a.179.179,0,0,1,.2.173.319.319,0,0,1-.024.113l-3.052,8.854a.208.208,0,0,0,.037.183A.194.194,0,0,0,24.867,28ZM8.315,18.6a.2.2,0,0,1,.2.2v8.989A.21.21,0,0,0,8.735,28h2.39a.207.207,0,0,0,.208-.211V24.008a.114.114,0,0,1,.115-.13.177.177,0,0,1,.149.1.08.08,0,0,0,.01.013l2.812,3.782A.517.517,0,0,0,14.8,28h2.8a.21.21,0,0,0,.173-.109.2.2,0,0,0-.026-.219c-.008-.012-3.511-4.818-3.547-4.868-.011-.015-.015-.024-.022-.035a.148.148,0,0,1-.017-.043.119.119,0,0,1-.006-.032.3.3,0,0,1,.042-.126l0-.006L17.138,18.3a.2.2,0,0,0-.17-.3H14.309a.529.529,0,0,0-.381.229L11.607,21.4c-.072.1-.142.109-.156.109h0a.106.106,0,0,1-.115-.106V18.211A.214.214,0,0,0,11.117,18H8.054A.055.055,0,0,0,8,18.052v.5a.055.055,0,0,0,.054.052h.261Z",
    transform: "translate(-1.333 -1)",
    fill: "#d50000",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKia);
export default __webpack_public_path__ + "static/media/KIA.f1330bdba1c2d32fb3811bf2d1541e78.svg";
export { ForwardRef as ReactComponent };